<template lang="pug">
    v-dialog(v-model="dialog" max-width="480" scrollable persistent :fullscreen="$vuetify.breakpoint.smAndDown")
        v-card(tile)
            v-card-title.title.caption--text {{title}}
            v-card-text
                v-select(chips multiple v-model="selectedColumns" clearable
                :items="searchColumns"
                    :label="searchColumnsLabel")
                v-select(chips multiple v-model="selectedTypes" clearable
                :items="companyTypes"
                    :label="searchTypesLabel")
                v-select(chips multiple v-model="selectedStatuses" clearable
                :items="companyStatuses"
                    :label="searchStatusesLabel")
            v-layout(tag="v-card-actions")
                v-btn(@click="close" color="grey" depressed).px-3.white--text
                    v-icon(left dark) mdi-cancel
                    | {{$t('general.cancel')}}
                v-spacer
                v-btn(@click="onSearchAdvanceSubmit" color="primary" depressed).px-3
                    v-icon(left dark) mdi-check
                    | {{$t('general.ok')}}
</template>

<script>
import general from "../../mixins/general";

export default {
  name: "AdvancedSearchDialog",
  mixins: [general],
  props: {
    title: String,
    searchColumnsLabel: String,
    searchTypesLabel: String,
    searchStatusesLabel: String
  },
  data() {
    return {
      dialog: false,
      selectedColumns: [],
      selectedTypes: [],
      selectedStatuses: []
    };
  },
  computed: {
    showing: {
      get() {
        return this.dialog;
      }
    },
    searchColumns: {
      get() {
        return [
          {
            value: "code",
            text: this.$t("pages.settings.company.table.headers.code.title")
          },
          {
            value: "name",
            text: this.$t("pages.settings.company.table.headers.name.title")
          }
        ];
      }
    }
  },
  methods: {
    show() {
      this.dialog = true;
      this.fetchCompanyTypes(undefined);
    },
    close() {
      this.dialog = false;
    },
    onSearchAdvanceSubmit() {
      this.close();
      this.$emit("submit", {
        selectedColumns: this.selectedColumns,
        selectedTypes: this.selectedTypes,
        selectedStatuses: this.selectedStatuses
      });
    }
  }
};
</script>
